import contacts from "./data";
import "./contact.css";

const contact = () => {
  return ( 
    <section id="contact">
      <h2 data-aos="fade-up">Contact Us</h2>
      <p data-aos="fade-up">Send us your concerns via one of the links below</p>
      <div className="container contact__container">
      <div className="container contact__container" data-aos="fade-up">
        {contacts.map((contact) => (
          <a
            key={contact.id}
            href={contact.link}
            target="_blank"
            rel="noopener noreferrer"
            data-aos="fade-right"
          >
            {contact.icon}
          </a>
        ))}
      </div>
      </div>
    </section>
  );
};

export default contact;
